import { render, staticRenderFns } from "./PermissionsUser.vue?vue&type=template&id=64984d3b&scoped=true&"
import script from "./PermissionsUser.vue?vue&type=script&lang=js&"
export * from "./PermissionsUser.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PermissionsUser.vue?vue&type=style&index=1&id=64984d3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64984d3b",
  null
  
)

export default component.exports